import { forwardRef, useCallback } from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconFilledProps, IconRender } from '../types.ts';

const Check = forwardRef<SVGSVGElement | null, IconFilledProps>(function Check({ filled, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z'
          fill={filled ? 'transparent' : color}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17.3703 8.8832C17.5582 9.08555 17.5465 9.40192 17.3441 9.58982L11.0636 15.4217C10.5709 15.8792 9.80459 15.8651 9.32916 15.3896L6.52342 12.5839C6.32816 12.3886 6.32816 12.072 6.52342 11.8768L6.87697 11.5232C7.07223 11.328 7.38882 11.328 7.58408 11.5232L10.2195 14.1586L16.3235 8.49063C16.5258 8.30273 16.8422 8.31445 17.0301 8.5168L17.3703 8.8832Z'
          fill={filled ? 'transparent' : color}
        />
        {/* filled */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM17.3442 9.58981C17.5465 9.40191 17.5583 9.08554 17.3704 8.88318L17.0301 8.51679C16.8422 8.31443 16.5259 8.30271 16.3235 8.49062L10.2195 14.1586L7.58414 11.5232C7.38887 11.3279 7.07229 11.3279 6.87703 11.5232L6.52348 11.8768C6.32821 12.072 6.32821 12.3886 6.52348 12.5839L9.32922 15.3896C9.80465 15.865 10.571 15.8792 11.0637 15.4217L17.3442 9.58981Z'
          fill={filled ? color : 'transparent'}
        />
      </>
    ),
    [filled],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'check-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Check;
